'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _reactSelectPlus = require('react-select-plus');

var _reactSelectPlus2 = _interopRequireDefault(_reactSelectPlus);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _pickValidProps = require('react-utils/pickValidProps');

var _pickValidProps2 = _interopRequireDefault(_pickValidProps);

var _Dom = require('../utils/Dom');

var _Functions = require('../core/Functions');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _OptionTypes = require('../types/OptionTypes');

var _PlacementConstants = require('../tooltip/PlacementConstants');

var _UITypeaheadResultsItem = require('../typeahead/results/UITypeaheadResultsItem');

var _UITypeaheadResultsItem2 = _interopRequireDefault(_UITypeaheadResultsItem);

var _ButtonConstants = require('../button/ButtonConstants');

var _UILink = require('../link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UIControlledPopover = require('../tooltip/UIControlledPopover');

var _UIControlledPopover2 = _interopRequireDefault(_UIControlledPopover);

var _UILoadingSpinner = require('../loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _UISearchInput = require('../input/UISearchInput');

var _UISearchInput2 = _interopRequireDefault(_UISearchInput);

var _MultiSelectValue = require('./utils/MultiSelectValue');

var _MultiSelectValue2 = _interopRequireDefault(_MultiSelectValue);

var _UISelectWithButtonAnchor = require('./internal/UISelectWithButtonAnchor');

var _UISelectWithButtonAnchor2 = _interopRequireDefault(_UISelectWithButtonAnchor);

var _UISelectWithInputAnchor = require('./internal/UISelectWithInputAnchor');

var _UISelectWithInputAnchor2 = _interopRequireDefault(_UISelectWithInputAnchor);

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _customRenderer = require('../utils/propTypes/customRenderer');

var customRenderer = _interopRequireWildcard(_customRenderer);

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

var _decorators = require('../utils/propTypes/decorators');

var _Tether = require('../constants/Tether');

var _UIButton = require('../button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _Memoize = require('../core/Memoize');

var _FieldsetContext = require('../context/FieldsetContext');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Async = _reactSelectPlus2.default.Async,
    Creatable = _reactSelectPlus2.default.Creatable,
    stripDiacritics = _reactSelectPlus2.default.stripDiacritics;


var SELECT_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__selectplus--small'
};

var isVirtualized = function isVirtualized(menuRenderer) {
  return menuRenderer && menuRenderer.displayName === 'virtualizedMenuRenderer';
};

var LoadMoreComponent = function LoadMoreComponent(_ref) {
  var options = _ref.options,
      pagination = _ref.pagination;

  return _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      'span',
      { className: 'private-form__selectplus--load-more-count' },
      pagination.length ? _I18n2.default.text('salesUI.UISelect.andMore', {
        count: pagination.length - options.length
      }) : ''
    ),
    _react2.default.createElement(
      _UILink2.default,
      null,
      _I18n2.default.text('salesUI.UISelect.loadMore')
    )
  );
};

var multiDummyOption = void 0;
var getMultiDummyOption = function getMultiDummyOption() {
  multiDummyOption = multiDummyOption || {
    disabled: true,
    dropdownText: _I18n2.default.text('salesUI.UISelect.allOptionsSelected'),
    isSpecial: true,
    title: '',
    value: '__MULTI_DUMMY_OPTION__'
  };
  return multiDummyOption;
};

var loadMoreOptionValue = '__LOAD_MORE_OPTION__';
var getLoadMoreOption = function getLoadMoreOption(_ref2) {
  var input = _ref2.input,
      loadMoreComponent = _ref2.loadMoreComponent,
      options = _ref2.options,
      pagination = _ref2.pagination;

  return {
    dropdownClassName: 'private-form__selectplus--load-more',
    dropdownText: customRenderer.render(loadMoreComponent, {
      options: options,
      pagination: pagination
    }),
    input: input,
    isSpecial: true,
    title: '',
    value: loadMoreOptionValue
  };
};

var getIsLoadingOption = function getIsLoadingOption() {
  return {
    disabled: true,
    dropdownClassName: 'private-dropdown__loading',
    dropdownText: _react2.default.createElement(_UILoadingSpinner2.default, { layout: 'centered', size: 'small' }),
    isSpecial: true,
    title: '',
    value: '__IS_LOADING_OPTION__'
  };
};

var getInputProps = function getInputProps(disabled, id, searchable, computedAnchorType, handleAutosize, handlePaste, readOnly) {
  if (disabled || !searchable || computedAnchorType !== 'combined' || readOnly) return {};
  return {
    id: id,
    onAutosize: handleAutosize,
    onPaste: handlePaste
  };
};

var makeNewOptionsCache = function makeNewOptionsCache(optionsCache, options) {
  var newOptionsCache = _extends({}, optionsCache);
  var addOptionToCache = function addOptionToCache(option) {
    newOptionsCache[option.value] = option;
  };
  var addOptionListToCache = function addOptionListToCache(optionList) {
    optionList.forEach(function (option) {
      if (Array.isArray(option.options)) {
        addOptionListToCache(option.options);
      } else {
        addOptionToCache(option);
      }
    });
  };
  // Recursively add all options, including those within groups, to the cache.
  addOptionListToCache(options);
  return newOptionsCache;
};

function promptTextCreator(label) {
  return _I18n2.default.text('salesUI.UISelect.createOption', {
    label: _I18n2.default.SafeString(label)
  });
}

/**
 * "Cleans" an input value. Matches the filter react-select-plus applies to the input passed to `loadOptionsProxy`. (#5289)
 */
function filterInputValue(inputValue, _ref3) {
  var _ref3$ignoreAccents = _ref3.ignoreAccents,
      ignoreAccents = _ref3$ignoreAccents === undefined ? true : _ref3$ignoreAccents,
      _ref3$ignoreCase = _ref3.ignoreCase,
      ignoreCase = _ref3$ignoreCase === undefined ? true : _ref3$ignoreCase;

  // https://github.com/HubSpot/react-select-plus/blob/8ae7465fc9b6b9600a01e4e23de97f2d403fd139/src/Async.js#L155-L163
  var transformedInputValue = inputValue;
  if (ignoreAccents) {
    transformedInputValue = stripDiacritics(transformedInputValue);
  }
  if (ignoreCase) {
    transformedInputValue = transformedInputValue.toLowerCase();
  }
  return transformedInputValue;
}

var UISelectCore = _react2.default.createClass({
  displayName: 'UISelectCore',

  propTypes: {
    allowCreate: _react.PropTypes.bool,
    anchorType: _react.PropTypes.oneOf(['auto', 'button', 'combined', 'input']),
    autoFocus: _react.PropTypes.bool,
    autoload: _react.PropTypes.bool,
    ButtonContent: _UISelectWithButtonAnchor2.default.propTypes.ButtonContent,
    buttonSize: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.SIZE_CLASSES)),
    buttonUse: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired,
    cache: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.bool]),
    clearable: _react.PropTypes.bool.isRequired,
    closeOnTargetLeave: _react.PropTypes.bool,
    delimiter: _react.PropTypes.string.isRequired,
    disabled: _react.PropTypes.bool,
    dropdownClassName: _react.PropTypes.string,
    dropdownFooter: _react.PropTypes.node,
    error: _react.PropTypes.bool,
    filterOptions: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.bool]),
    id: _react.PropTypes.string,
    ignoreAccents: (0, _decorators.hidden)(_react.PropTypes.bool),
    ignoreCase: (0, _decorators.hidden)(_react.PropTypes.bool),
    inputComponent: _react.PropTypes.func,
    inputRef: _refObject2.default,
    inputValue: _react.PropTypes.string,
    isLoading: _react.PropTypes.bool,
    itemComponent: _component2.default,
    loadMoreComponent: customRenderer.propType,
    loadOptions: _react.PropTypes.func,
    menuRenderer: _react.PropTypes.func,
    menuWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['auto'])]),
    minimumSearchCount: _react.PropTypes.number,
    multi: _react.PropTypes.bool.isRequired,
    multiCollapseLimit: _react.PropTypes.number,
    noResultsText: (0, _createLazyPropType2.default)(_react.PropTypes.node),
    onChange: _react.PropTypes.func,
    onInputKeyDown: _react.PropTypes.func,
    onInputChange: _react.PropTypes.func,
    onInputValueChange: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    onPaste: _react.PropTypes.func,
    onSelectedOptionChange: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    optionComponent: _react.PropTypes.func,
    options: _react.PropTypes.arrayOf(_OptionTypes.OptionOrGroupType),
    optionRenderer: _react.PropTypes.func,
    optionRendererIgnoresSpecialOptions: _react.PropTypes.bool,
    placeholder: (0, _createLazyPropType2.default)(_react.PropTypes.node).isRequired,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS),
    promptTextCreator: _react.PropTypes.func,
    readOnly: _react.PropTypes.bool,
    resetValue: _OptionTypes.ValueType,
    resultsClassName: _react.PropTypes.string,
    search: _react.PropTypes.string,
    searchable: _react.PropTypes.bool.isRequired,
    searchClassName: _react.PropTypes.string,
    searchPlaceholder: (0, _createLazyPropType2.default)(_react.PropTypes.string).isRequired,
    searchPromptText: (0, _createLazyPropType2.default)(_react.PropTypes.string).isRequired,
    splitRegex: _react.PropTypes.object,
    tabIndex: _react.PropTypes.number,
    value: _OptionTypes.ValueType,
    valueComponent: _component2.default,
    valueRenderer: _react.PropTypes.func,
    _forcePlaceholder: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      allowCreate: false,
      anchorType: 'auto',
      autoload: true,
      buttonSize: 'default',
      buttonUse: 'form',
      clearable: false,
      delimiter: ';',
      open: false,
      ignoreAccents: true,
      ignoreCase: true,
      inputComponent: _UISearchInput2.default,
      itemComponent: 'span',
      loadMoreComponent: LoadMoreComponent,
      minimumSearchCount: 8,
      multi: false,
      optionRendererIgnoresSpecialOptions: false,
      placeholder: function placeholder() {
        return _I18n2.default.text('salesUI.UISelect.placeholder');
      },
      promptTextCreator: promptTextCreator,
      resetValue: '',
      searchable: true,
      searchPlaceholder: function searchPlaceholder() {
        return _I18n2.default.text('salesUI.UISearchableSelectInput.placeholder');
      },
      searchPromptText: function searchPromptText() {
        return _I18n2.default.text('salesUI.UISelect.typeToSearch');
      },
      splitRegex: /;/,
      value: '',
      _forcePlaceholder: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      controlWidth: 0,
      inputValue: '',
      isLoading: false,
      optionsCache: {},
      paginationCache: {},
      resetOption: null
    };
  },
  componentWillMount: function componentWillMount() {
    this.cacheOptions(this.props);
    this.generateResetOption(this.props);
    this._isMounted = true; // not strictly true, but componentDidMount() fires too late!
    this._getInputProps = (0, _Memoize.memoizeLastResult)(getInputProps);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    this.cacheOptions(nextProps);
    this.generateResetOption(nextProps);
    if (!this.props.open && nextProps.open) {
      this.resetPaginationCache();
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var controlEl = (0, _reactDom.findDOMNode)(this._anchorRef);
    if (!controlEl) {
      return;
    }

    if (this.isCollapsed(prevProps) && !this.isCollapsed(this.props)) {
      this.focus();
    }

    var controlWidth = this.computeControlWidth(controlEl);
    if (controlWidth !== this.state.controlWidth) {
      this.setState({
        controlWidth: controlWidth
      });
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this._isMounted = false;
  },
  cacheOptions: function cacheOptions(_ref4) {
    var options = _ref4.options;

    // Cache options provided via props (required for certain async scenarios, and for paste handling)
    var optionsCache = this.state.optionsCache;

    if (options) {
      var newOptionsCache = makeNewOptionsCache(optionsCache, options);
      this.setState({ optionsCache: newOptionsCache });
    }
  },
  resetPaginationCache: function resetPaginationCache() {
    // If async caching is disabled, paginationCache should not persist across searches
    var cache = this.props.cache;

    if (cache === null || cache === false) {
      this.setState({ paginationCache: {} });
    }
  },
  generateResetOption: function generateResetOption(_ref5) {
    var placeholder = _ref5.placeholder,
        resetValue = _ref5.resetValue;
    var resetOption = this.state.resetOption;

    var newResetOption = {
      buttonText: (0, _lazyEval2.default)(placeholder),
      dropdownText: (0, _lazyEval2.default)(placeholder),
      value: resetValue
    };
    if (!(resetOption && resetOption.buttonText === newResetOption.buttonText && resetOption.value === newResetOption.value)) {
      this.setState({
        resetOption: newResetOption
      });
    }
  },
  areOptionsToggleable: function areOptionsToggleable(_ref6) {
    var anchorType = _ref6.anchorType,
        multi = _ref6.multi;

    // Return true if we show options as checkboxes in the dropdown (#1976)
    var computedAnchorType = this.getAnchorType({ anchorType: anchorType, multi: multi });
    return multi && computedAnchorType !== 'combined';
  },
  defaultOptionRenderer: function defaultOptionRenderer(option) {
    var _props = this.props,
        anchorType = _props.anchorType,
        itemComponent = _props.itemComponent,
        multi = _props.multi,
        optionComponent = _props.optionComponent,
        value = _props.value;


    var isOptionGroup = !!option.options;
    var isSelectAll = isOptionGroup && !!option.selectAll;

    var toggleable = this.areOptionsToggleable({ anchorType: anchorType, multi: multi }) && option.className !== 'Select-create-option-placeholder' && !option.isSpecial && !(isOptionGroup && !isSelectAll);

    var nestedOptionCount = 0;
    var selectedOptionCount = 0;
    if (isSelectAll) {
      var tabulate = function tabulate(o) {
        if (o.options) {
          o.options.forEach(tabulate);
        } else if (!o.disabled) {
          nestedOptionCount += 1;
          if (Array.isArray(value) && value.indexOf(o.value) !== -1) selectedOptionCount += 1;
        }
      };
      tabulate(option);
    }

    var isIndeterminate = void 0;
    var isSelected = void 0;

    if (typeof option.getCheckboxState === 'function') {
      var _option$getCheckboxSt = option.getCheckboxState(option),
          indeterminate = _option$getCheckboxSt.indeterminate,
          checked = _option$getCheckboxSt.checked;

      isIndeterminate = !!indeterminate;
      isSelected = !!checked;
    } else {
      isIndeterminate = isSelectAll && 0 < selectedOptionCount && selectedOptionCount < nestedOptionCount;

      isSelected = isSelectAll ? nestedOptionCount === selectedOptionCount : !!(toggleable && Array.isArray(value) && value.indexOf(option.value) !== -1);
    }

    return _react2.default.createElement(_UITypeaheadResultsItem2.default, {
      itemComponent: optionComponent || itemComponent,
      isIndeterminate: isIndeterminate,
      isSelected: isSelected,
      onToggle: this.handleOptionToggle.bind(this, option),
      option: option,
      style: option.dropdownStyle,
      toggleable: toggleable,
      _useButton: !toggleable
    });
  },
  optionRendererProxy: function optionRendererProxy(option) {
    var _props2 = this.props,
        optionRenderer = _props2.optionRenderer,
        optionRendererIgnoresSpecialOptions = _props2.optionRendererIgnoresSpecialOptions;

    if (optionRenderer == null || option.isSpecial && optionRendererIgnoresSpecialOptions) {
      return this.defaultOptionRenderer(option);
    }
    return optionRenderer(option);
  },
  defaultValueRenderer: function defaultValueRenderer(option) {
    var _props3 = this.props,
        itemComponent = _props3.itemComponent,
        valueComponent = _props3.valueComponent;

    return _react2.default.createElement(_UITypeaheadResultsItem2.default, {
      'aria-invalid': option.invalid,
      itemComponent: valueComponent || itemComponent,
      key: option.value,
      option: _extends({}, option, { help: undefined }),
      _useButton: false,
      _useDropdownText: false
    });
  },
  filterOptionsProxy: function filterOptionsProxy(options, input, excludeOptions) {
    var _props4 = this.props,
        anchorType = _props4.anchorType,
        clearable = _props4.clearable,
        filterOptions = _props4.filterOptions,
        ignoreAccents = _props4.ignoreAccents,
        ignoreCase = _props4.ignoreCase,
        isLoadingProp = _props4.isLoading,
        loadMoreComponent = _props4.loadMoreComponent,
        multi = _props4.multi,
        resetValue = _props4.resetValue,
        value = _props4.value;
    var _state = this.state,
        isLoading = _state.isLoading,
        paginationCache = _state.paginationCache,
        resetOption = _state.resetOption;


    var filterOptionsFunc = void 0;
    if (filterOptions === false) {
      filterOptionsFunc = function filterOptionsFunc(x) {
        return x;
      };
    } else if (typeof filterOptions === 'function') {
      filterOptionsFunc = filterOptions;
    } else {
      filterOptionsFunc = this.getDefaultFilterOptionsFunc();
    }

    var showSelectedOptions = this.areOptionsToggleable({
      anchorType: anchorType,
      multi: multi
    });

    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    var filteredOptions = filterOptionsFunc.apply(undefined, [options, input, showSelectedOptions ? [] : excludeOptions].concat(rest));

    if (input.length === 0) {
      // Add multi dummy option, if needed (#1256)
      if (multi && options.length > 0 && filteredOptions.length === 0) {
        filteredOptions = filteredOptions.concat(getMultiDummyOption());
      }

      // Add resetOption, if needed (#2300)
      if (clearable && !multi && value != null && value !== resetValue) {
        filteredOptions = [resetOption].concat(filteredOptions);
      }
    }

    if (isLoading || isLoadingProp) {
      // Add "Loading..." option, if needed
      filteredOptions = filteredOptions.concat(getIsLoadingOption());
    } else {
      var paginationCacheKey = filterInputValue(input, {
        ignoreAccents: ignoreAccents,
        ignoreCase: ignoreCase
      });
      var pagination = paginationCache[paginationCacheKey];
      // Add "Load more" option, if needed (#2031)
      if (pagination && pagination.hasMore) {
        filteredOptions = filteredOptions.concat(getLoadMoreOption({
          input: input,
          isLoading: isLoading,
          loadMoreComponent: loadMoreComponent,
          options: options,
          pagination: pagination
        }));
      }
    }

    return filteredOptions;
  },
  getDefaultFilterOptionsFunc: function getDefaultFilterOptionsFunc() {
    return _reactSelectPlus2.default.defaultProps.filterOptions;
  },
  selectValueProxy: function selectValueProxy(selectValue, selectedOption) {
    // If this is a "Load more" option, trigger load.
    if (selectedOption.value === loadMoreOptionValue) {
      this.triggerLoadMore();
    }
    // Prevent "special" options from being selected.
    if (selectedOption.isSpecial) {
      return;
    }
    selectValue(selectedOption);
  },
  creatableOnInputChangeProxy: function creatableOnInputChangeProxy(str) {
    var internalCreatableSelect = this.getInternalCreatableSelect();
    var newInputValue = this.handleInputChange(str);
    internalCreatableSelect.inputValue = newInputValue;
    return newInputValue;
  },
  triggerLoadMore: function triggerLoadMore() {
    // Trick Select.Async into calling loadOptions again, then move focus up one option
    var internalSelect = this.getInternalSelect();
    var internalAsyncSelect = this.getInternalAsyncSelect();
    if (!internalSelect || !internalAsyncSelect || !internalAsyncSelect.loadOptions) {
      return;
    }
    var _props5 = this.props,
        ignoreAccents = _props5.ignoreAccents,
        ignoreCase = _props5.ignoreCase;

    var visibleOptions = internalSelect._visibleOptions;
    var loadMoreOption = visibleOptions[visibleOptions.length - 1];
    var transformedInputValue = filterInputValue(loadMoreOption.input, {
      ignoreAccents: ignoreAccents,
      ignoreCase: ignoreCase
    });
    if (internalAsyncSelect._cache) {
      delete internalAsyncSelect._cache[transformedInputValue];
    }
    internalAsyncSelect.loadOptions(transformedInputValue);
    var normalOptions = internalSelect.props.options;
    internalSelect.setState({
      focusedOption: normalOptions[normalOptions.length - 1]
    });
  },
  toggleGroup: function toggleGroup(groupToToggle, willBeSelected) {
    var value = this.props.value;

    var valueCopy = (value || []).slice(0);
    var newValue = valueCopy;
    if (willBeSelected) {
      var addOptionValue = function addOptionValue(o) {
        if (o.options) {
          o.options.filter(function (option) {
            return !option.disabled;
          }).forEach(addOptionValue);
        } else {
          if (newValue.indexOf(o.value) === -1) newValue.push(o.value);
        }
      };
      addOptionValue(groupToToggle);
    } else {
      var removeOptionValue = function removeOptionValue(o) {
        if (o.options) {
          o.options.filter(function (option) {
            return !option.disabled;
          }).forEach(removeOptionValue);
        } else {
          newValue = newValue.filter(function (v) {
            return v !== o.value;
          });
        }
      };
      removeOptionValue(groupToToggle);
    }
    this.setMultiValues(newValue);
  },
  toggleMultiValue: function toggleMultiValue(valueToToggle, willBeSelected) {
    var value = this.props.value;

    var valueCopy = (value || []).slice(0);
    var newValue = null;
    if (willBeSelected) {
      newValue = valueCopy.concat(valueToToggle);
    } else {
      newValue = valueCopy.filter(function (v) {
        return v !== valueToToggle;
      });
    }
    this.setMultiValues(newValue);
  },
  addMultiValues: function addMultiValues(addValues) {
    var value = this.props.value;

    var newValues = (value || []).slice(0);
    addValues.forEach(function (v) {
      if (newValues.indexOf(v) === -1 && v !== '') newValues.push(v);
    });
    this.setMultiValues(newValues);
  },
  setMultiValues: function setMultiValues(newValues) {
    var optionsCache = this.state.optionsCache;
    // Map values to options

    var newOptions = newValues.map(function (v) {
      return optionsCache[v] || { text: v, value: v };
    });
    this.handleChange(newOptions);
  },
  handleChange: function handleChange(option) {
    // react-select-plus gives us an option object or null, which we pass to
    // onSelectedOptionChange, but our onChange handler expects just the new value.
    var _props6 = this.props,
        onChange = _props6.onChange,
        onSelectedOptionChange = _props6.onSelectedOptionChange,
        value = _props6.value;

    (0, _Functions.callIfPossible)(onSelectedOptionChange, (0, _SyntheticEvent2.default)(option));
    var newVal = null;
    if (Array.isArray(option)) {
      newVal = option.filter(Boolean).map(function (o) {
        return o.value;
      });
    } else if (option) {
      newVal = option.value;
    }
    if (newVal !== value) {
      onChange((0, _SyntheticEvent2.default)(newVal));
    }
  },
  handleInputKeyDown: function handleInputKeyDown(evt) {
    var _props7 = this.props,
        anchorType = _props7.anchorType,
        multi = _props7.multi,
        onInputKeyDown = _props7.onInputKeyDown,
        value = _props7.value;
    var key = evt.key;


    (0, _Functions.callIfPossible)(onInputKeyDown, evt);
    if (evt.defaultPrevented) {
      return;
    }

    // In multi-mode, we need to handle ENTER to allow the focused option to be toggled.
    if (key === 'Enter' && multi && this.getAnchorType({ anchorType: anchorType, multi: multi }) !== 'combined') {
      var internalSelect = this.getInternalSelect();
      if (!internalSelect) {
        return;
      }
      var focusedOption = internalSelect._focusedOption;
      if (!focusedOption) {
        return;
      }
      if (focusedOption.value === loadMoreOptionValue) {
        this.triggerLoadMore();
        return;
      }
      if (focusedOption.isSpecial || focusedOption.clearableValue === false) {
        return;
      }
      var valueToToggle = focusedOption.value;
      var willBeSelected = value.indexOf(valueToToggle) === -1;
      this.toggleMultiValue(valueToToggle, willBeSelected);
      evt.preventDefault();
    }
  },
  handleOptionToggle: function handleOptionToggle(option, _ref7) {
    var checked = _ref7.target.checked;

    var willBeSelected = checked;
    if (option.options && option.selectAll) {
      this.toggleGroup(option, willBeSelected);
    } else {
      var valueToToggle = option.value;
      this.toggleMultiValue(valueToToggle, willBeSelected);
    }
  },
  handleClose: function handleClose(evt) {
    var _props8 = this.props,
        onClose = _props8.onClose,
        onOpenChange = _props8.onOpenChange; // eslint-disable-line react/prop-types

    onOpenChange((0, _SyntheticEvent2.default)(false));
    (0, _Functions.callIfPossible)(onClose, evt);
  },
  handleOpen: function handleOpen(evt) {
    var _props9 = this.props,
        onOpen = _props9.onOpen,
        onOpenChange = _props9.onOpenChange; // eslint-disable-line react/prop-types

    onOpenChange((0, _SyntheticEvent2.default)(true));
    (0, _Functions.callIfPossible)(onOpen, evt);
  },
  triggerOpen: function triggerOpen() {
    var onOpenChange = this.props.onOpenChange;

    onOpenChange((0, _SyntheticEvent2.default)(true));
  },
  handleInputChange: function handleInputChange(str) {
    var _props10 = this.props,
        loadOptions = _props10.loadOptions,
        multi = _props10.multi,
        onInputChange = _props10.onInputChange;

    (0, _Functions.callIfPossible)(onInputChange, str);
    this.setState({ inputValue: str });

    // Handle typing multi values separated by splitRegex.
    if (multi) {
      var splitValues = this.getSplitValuesFromString(str, false);
      if (splitValues.length > 0) {
        this.addMultiValues(splitValues);
        return '';
      }
    }

    // If the user typed a request that will hit the cache, ignore any pending request.
    if (loadOptions != null) {
      var internalAsyncSelect = this.getInternalAsyncSelect();
      if (internalAsyncSelect != null) {
        if (internalAsyncSelect._cache && internalAsyncSelect._cache.hasOwnProperty(str)) {
          internalAsyncSelect._callback = null;
          this.setState({
            isLoading: false
          });
        }
      }
    }

    return str;
  },
  handleInputValueChange: function handleInputValueChange(evt) {
    var onInputValueChange = this.props.onInputValueChange;

    (0, _Functions.callIfPossible)(onInputValueChange, evt);
    this.resetPaginationCache();
    this.setState({ inputValue: evt.target.value });
  },
  handlePaste: function handlePaste(evt) {
    var _props11 = this.props,
        multi = _props11.multi,
        onPaste = _props11.onPaste;

    // Allow developers to override default paste handling.

    (0, _Functions.callIfPossible)(onPaste, evt);
    if (evt.defaultPrevented) {
      return;
    }

    if (!multi) return;

    var clipboardData = evt.clipboardData || window.clipboardData;
    var pastedText = clipboardData.getData('Text');
    var splitValues = this.getSplitValuesFromString(pastedText, true);

    if (splitValues.length > 0) {
      evt.preventDefault();
      this.addMultiValues(splitValues);
    }
  },
  getSplitValuesFromString: function getSplitValuesFromString(str, includeLastValue) {
    var _props12 = this.props,
        allowCreate = _props12.allowCreate,
        splitRegex = _props12.splitRegex;

    var strParts = str.split(splitRegex).map(function (s) {
      return s.trim();
    });

    if (!includeLastValue) {
      strParts = strParts.slice(0, strParts.length - 1);
    }

    if (strParts.length === 0) return [];

    // Create a map of option labels to options
    var optionsCache = this.state.optionsCache;

    var reverseOptionsCache = {};
    Object.keys(optionsCache).forEach(function (key) {
      var option = optionsCache[key];
      reverseOptionsCache[option.text || key] = option.value;
    });

    // For each piece, see if it maps to an option label. If so, add that option's value to
    // the result. Otherwise, if allowCreate is enabled, add a new option.
    var result = [];
    strParts.forEach(function (label) {
      if (reverseOptionsCache.hasOwnProperty(label)) {
        result.push(reverseOptionsCache[label]);
      } else if (allowCreate && result.indexOf(label) === -1) {
        result.push(label);
      }
    });
    return result;
  },
  getMenuWidth: function getMenuWidth() {
    var menuWidth = this.props.menuWidth;

    if (menuWidth === 'auto') {
      return '';
    }
    if (typeof menuWidth === 'number') {
      return menuWidth;
    }
    return Math.max(this.state.controlWidth, _Tether.MIN_MENU_WIDTH);
  },
  computeControlWidth: function computeControlWidth(controlEl) {
    var open = this.props.open;

    if (!controlEl || !open) {
      return 0;
    }
    var exactWidth = controlEl.getBoundingClientRect().width;
    var roundedWidth = window.chrome ? Math.floor(exactWidth) : exactWidth;
    return roundedWidth - 2; // account for 1px border added by UIPopover
  },
  focus: function focus() {
    try {
      this._anchorRef.focus();
    } catch (e) {
      /* ¯\_(ツ)_/¯ */
    }
  },
  handleAutosize: function handleAutosize() {
    if (this._popover) {
      this._popover.reposition();
    }
  },
  dropdownContentRefCallback: function dropdownContentRefCallback(dropdownEl) {
    if (dropdownEl) {
      dropdownEl.addEventListener('mousedown', this.handleMouseDownOnDropdown);
    }
  },
  anchorRefCallback: function anchorRefCallback(anchorRef) {
    var _state2 = this.state,
        controlWidth = _state2.controlWidth,
        target = _state2.target;

    this._anchorRef = anchorRef;
    var newTarget = (0, _reactDom.findDOMNode)(this._anchorRef);
    var newControlWidth = this.computeControlWidth(newTarget);
    if (target !== newTarget || controlWidth !== newControlWidth) {
      this.setState({
        controlWidth: newControlWidth,
        target: newTarget
      });
    }
  },
  popoverRefCallback: function popoverRefCallback(ref) {
    this._popover = ref;
  },
  selectRefCallback: function selectRefCallback() {
    // Hackily override Select's selectValue and handleMouseDownOnMenu to support "Load more"
    var internalSelect = this.getInternalSelect();
    if (!internalSelect) return;
    internalSelect.selectValue = this.selectValueProxy.bind(this, internalSelect.selectValue);
    var internalCreatableSelect = this.getInternalCreatableSelect();
    if (!internalCreatableSelect) return;
    internalCreatableSelect.onInputChange = this.creatableOnInputChangeProxy;
  },
  getInternalSelect: function getInternalSelect() {
    // Return our react-select Select instance, or null
    if (!this._anchorRef) {
      return null;
    }
    if (this._anchorRef.getInternalSelect) {
      return this._anchorRef.getInternalSelect();
    }
    return this._anchorRef.select || this._anchorRef;
  },
  getInternalCreatableSelect: function getInternalCreatableSelect() {
    // Return our react-select Creatable instance, or null
    if (!this._anchorRef) {
      return null;
    }
    if (this._anchorRef.constructor === Creatable) {
      return this._anchorRef;
    }
    return null;
  },
  getInternalAsyncSelect: function getInternalAsyncSelect() {
    // Return our react-select Async instance, or null
    if (!this._anchorRef) {
      return null;
    }
    if (this._anchorRef.getInternalAsyncSelect) {
      return this._anchorRef.getInternalAsyncSelect();
    }
    if (this._anchorRef.constructor === Async) {
      return this._anchorRef;
    }
    return null;
  },
  handleMouseDownOnDropdown: function handleMouseDownOnDropdown(evt) {
    // react-select-plus normally closes the dropdown and blurs the input on mousedown. We need to
    // prevent that behavior for certain elements.
    var target = evt.target;

    if ((0, _Dom.closest)(target, '.private-dropdown__footer-container')) {
      evt.stopPropagation();
      evt.preventDefault();
      return;
    }
    if ((0, _Dom.closest)(target, '.private-form__selectplus--load-more')) {
      this.triggerLoadMore();
      evt.stopPropagation();
      evt.preventDefault();
      return;
    }
    if ((0, _Dom.closest)(target, '.private-checkbox')) {
      evt.stopPropagation();
      evt.preventDefault();
      return;
    }
  },
  loadOptionsProxy: function loadOptionsProxy(input, loadOptionsCallback) {
    var _props13 = this.props,
        open = _props13.open,
        loadOptions = _props13.loadOptions;


    if (input == null) {
      return;
    }

    // Show loading indicator until loadOptionsProxyCallback is called
    this.setState({
      isLoading: true
    });
    this._latestSearch = open ? input : null; // Special case: autoload search is designated as null

    // Keep a copy of all options returned by loadOptions
    var paginationCache = this.state.paginationCache;

    var proxyCallback = this.getLoadOptionsProxyCallback(open ? input : null, loadOptionsCallback);
    var result = void 0;
    try {
      result = loadOptions(input, proxyCallback, paginationCache[input || '']);
    } catch (error) {
      proxyCallback(error);
      setTimeout(function () {
        throw error;
      }, 0);
    }
    if (result && typeof result.then === 'function') {
      result.then(function (data) {
        proxyCallback(null, data || {});
      }, function (error) {
        proxyCallback(error);
        throw error;
      });
    }
  },
  getLoadOptionsProxyCallback: function getLoadOptionsProxyCallback(input, loadOptionsCallback) {
    var _this = this;

    var proxyCallback = function proxyCallback(error, data) {
      for (var _len2 = arguments.length, rest = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        rest[_key2 - 2] = arguments[_key2];
      }

      if (!_this._isMounted) return;

      var _state3 = _this.state,
          optionsCache = _state3.optionsCache,
          paginationCache = _state3.paginationCache;

      var newOptionsCache = optionsCache;
      var newPaginationCache = paginationCache;

      // Cache options so that we can render the selected value properly
      if (data && data.options) {
        newOptionsCache = makeNewOptionsCache(optionsCache, data.options);
        if (data.pagination) {
          newPaginationCache = _extends({}, paginationCache);
          newPaginationCache[input || ''] = data.pagination;
        }
      }
      var internalAsyncSelect = _this.getInternalAsyncSelect();
      _this.setState({
        isLoading: internalAsyncSelect && internalAsyncSelect._callback != null && _this._latestSearch !== input,
        optionsCache: newOptionsCache,
        paginationCache: newPaginationCache
      });

      loadOptionsCallback.apply(undefined, [error, data].concat(rest));
    };
    return proxyCallback;
  },
  getValueAsObject: function getValueAsObject(value) {
    // In async mode, react-select needs the current value's object form to render it
    var optionsCache = this.state.optionsCache;

    if (!optionsCache) {
      return value;
    }
    if (Array.isArray(value)) {
      return value.map(function (v) {
        return optionsCache.hasOwnProperty(v) ? optionsCache[v] : v;
      });
    }
    return optionsCache.hasOwnProperty(value) ? optionsCache[value] : value;
  },
  isCollapsed: function isCollapsed(_ref8) {
    var multi = _ref8.multi,
        multiCollapseLimit = _ref8.multiCollapseLimit,
        open = _ref8.open,
        value = _ref8.value;

    return multiCollapseLimit != null && value != null && value.length > multiCollapseLimit && multi && !open;
  },
  getAnchorType: function getAnchorType(_ref9) {
    var anchorType = _ref9.anchorType,
        multi = _ref9.multi;

    if (anchorType === 'auto') {
      return multi ? 'combined' : 'button';
    }
    return anchorType;
  },
  getNoResultsText: function getNoResultsText(_ref10) {
    var noResultsText = _ref10.noResultsText;

    if (noResultsText != null) return (0, _lazyEval2.default)(noResultsText);
    var inputValue = this.state.inputValue;

    return inputValue ? _I18n2.default.text('salesUI.UISelect.noResults') : _I18n2.default.text('salesUI.UISelect.typeToSearch');
  },
  getMenuRenderer: function getMenuRenderer(_ref11) {
    var itemComponent = _ref11.itemComponent,
        menuRenderer = _ref11.menuRenderer,
        menuWidth = _ref11.menuWidth,
        optionRenderer = _ref11.optionRenderer;

    if (isVirtualized(menuRenderer)) {
      if (optionRenderer || itemComponent !== UISelectCore.defaultProps.itemComponent) {
        _devLogger2.default.warn({
          message: 'UISelect: virtualize cannot be used with optionRenderer or itemComponent',
          key: 'UISelect: virtualizeCustomRenderer'
        });
        return undefined;
      }
      if (menuWidth === 'auto') {
        _devLogger2.default.warn({
          message: 'UISelect: virtualize canot be used with menuWidth="auto"',
          key: 'UISelect: virtualizeAutoWidth'
        });
        return undefined;
      }
      return menuRenderer(this.getMenuWidth());
    }
    return menuRenderer;
  },
  getValueComponent: function getValueComponent(_ref12) {
    var multi = _ref12.multi;

    return multi ? _MultiSelectValue2.default : _reactSelectPlus2.default.defaultProps.valueComponent;
  },
  renderDropdown: function renderDropdown(props) {
    var _props14 = this.props,
        closeOnTargetLeave = _props14.closeOnTargetLeave,
        onOpenChange = _props14.onOpenChange,
        open = _props14.open,
        placement = _props14.placement;

    return _react2.default.createElement(_UIControlledPopover2.default, {
      arrowSize: 'none',
      autoPlacement: 'vert',
      closeOnTargetLeave: closeOnTargetLeave,
      content: this.renderDropdownContent(props),
      onOpenChange: onOpenChange,
      open: open,
      placement: placement || 'bottom right',
      ref: this.popoverRefCallback,
      target: this.state.target
    });
  },
  renderDropdownContent: function renderDropdownContent(props) {
    var _props15 = this.props,
        dropdownClassName = _props15.dropdownClassName,
        menuRenderer = _props15.menuRenderer,
        resultsClassName = _props15.resultsClassName;

    var className = (0, _classNames2.default)(dropdownClassName, 'private-dropdown__results', {
      'private-dropdown--virtualized': isVirtualized(menuRenderer)
    });
    return _react2.default.createElement(
      'span',
      {
        className: (0, _classNames2.default)('private-typeahead-results', resultsClassName),
        'data-dropdown-results': true
      },
      _react2.default.createElement(
        'div',
        {
          className: className,
          ref: this.dropdownContentRefCallback,
          style: { width: this.getMenuWidth() }
        },
        props.children,
        this.renderDropdownFooter()
      )
    );
  },
  renderDropdownFooter: function renderDropdownFooter() {
    var dropdownFooter = this.props.dropdownFooter;

    if (!dropdownFooter) {
      return null;
    }
    return _react2.default.createElement(
      'div',
      { className: 'private-dropdown__footer-container' },
      dropdownFooter
    );
  },
  renderCollapsedAnchor: function renderCollapsedAnchor(combinedAnchorClassName, multiCollapseLimit, value, valueRenderer, rest) {
    var _this2 = this;

    var optionsCache = this.state.optionsCache;

    var renderedValues = value.slice(0, multiCollapseLimit).map(function (v) {
      var option = optionsCache[v] || { text: v, value: v };
      var valueNode = (valueRenderer || _this2.defaultValueRenderer)(option);
      return _react2.default.createElement(
        _MultiSelectValue2.default,
        {
          key: v,
          closeable: false,
          disabled: option.disabled,
          value: option
        },
        valueNode
      );
    });

    var hiddenValueCount = value.length - renderedValues.length;
    var andMoreNode = hiddenValueCount > 0 ? _react2.default.createElement(
      _UIButton2.default,
      { 'data-hidden-value-count': hiddenValueCount, use: 'transparent' },
      _I18n2.default.text('salesUI.UISelect.plusMore', {
        count: hiddenValueCount
      })
    ) : null;

    // We use the same classnames as react-select here, to get the same appearance.
    return _react2.default.createElement(
      _UIClickable2.default,
      _extends({}, (0, _pickValidProps2.default)({}, rest), {
        className: (0, _classNames2.default)('Select Select--multi', combinedAnchorClassName),
        'data-collapsed': true,
        onClick: this.triggerOpen,
        onFocus: this.triggerOpen
      }),
      _react2.default.createElement(
        'div',
        { className: 'Select-control' },
        _react2.default.createElement(
          'div',
          { className: 'Select-multi-value-wrapper' },
          renderedValues,
          andMoreNode
        ),
        _react2.default.createElement(
          'div',
          { className: 'Select-arrow-zone' },
          _react2.default.createElement('div', { className: 'Select-arrow' })
        )
      )
    );
  },
  render: function render() {
    var _this3 = this;

    var _props16 = this.props,
        allowCreate = _props16.allowCreate,
        anchorType = _props16.anchorType,
        autoFocus = _props16.autoFocus,
        ButtonContent = _props16.ButtonContent,
        buttonSize = _props16.buttonSize,
        buttonUse = _props16.buttonUse,
        className = _props16.className,
        clearable = _props16.clearable,
        closeOnTargetLeave = _props16.closeOnTargetLeave,
        disabled = _props16.disabled,
        error = _props16.error,
        id = _props16.id,
        ignoreAccents = _props16.ignoreAccents,
        ignoreCase = _props16.ignoreCase,
        inputRef = _props16.inputRef,
        inputValue = _props16.inputValue,
        isLoading = _props16.isLoading,
        itemComponent = _props16.itemComponent,
        loadOptions = _props16.loadOptions,
        menuRenderer = _props16.menuRenderer,
        menuWidth = _props16.menuWidth,
        multi = _props16.multi,
        multiCollapseLimit = _props16.multiCollapseLimit,
        noResultsText = _props16.noResultsText,
        __onChange = _props16.onChange,
        __onInputValueChange = _props16.onInputValueChange,
        onOpenChange = _props16.onOpenChange,
        __onSelectedOptionChange = _props16.onSelectedOptionChange,
        open = _props16.open,
        __optionComponent = _props16.optionComponent,
        optionRenderer = _props16.optionRenderer,
        options = _props16.options,
        placeholder = _props16.placeholder,
        readOnly = _props16.readOnly,
        resetValue = _props16.resetValue,
        searchable = _props16.searchable,
        searchClassName = _props16.searchClassName,
        searchPlaceholder = _props16.searchPlaceholder,
        searchPromptText = _props16.searchPromptText,
        __splitRegex = _props16.splitRegex,
        tabIndex = _props16.tabIndex,
        value = _props16.value,
        __valueComponent = _props16.valueComponent,
        valueRenderer = _props16.valueRenderer,
        rest = _objectWithoutProperties(_props16, ['allowCreate', 'anchorType', 'autoFocus', 'ButtonContent', 'buttonSize', 'buttonUse', 'className', 'clearable', 'closeOnTargetLeave', 'disabled', 'error', 'id', 'ignoreAccents', 'ignoreCase', 'inputRef', 'inputValue', 'isLoading', 'itemComponent', 'loadOptions', 'menuRenderer', 'menuWidth', 'multi', 'multiCollapseLimit', 'noResultsText', 'onChange', 'onInputValueChange', 'onOpenChange', 'onSelectedOptionChange', 'open', 'optionComponent', 'optionRenderer', 'options', 'placeholder', 'readOnly', 'resetValue', 'searchable', 'searchClassName', 'searchPlaceholder', 'searchPromptText', 'splitRegex', 'tabIndex', 'value', 'valueComponent', 'valueRenderer']);

    var resetOption = this.state.resetOption;


    var combinedAnchorClassName = (0, _classNames2.default)(className, 'private-form__selectplus', {
      'private-form__selectplus--multi': multi,
      'private-form__control--error': error,
      // follow convention of disabled className
      'is-readonly': readOnly
    });

    // Use an HOC around React Select, if applicable
    var SelectComponent = _reactSelectPlus2.default;
    if (loadOptions) {
      SelectComponent = _reactSelectPlus2.default.Async;
    } else if (allowCreate) {
      SelectComponent = _reactSelectPlus2.default.Creatable;
    }

    // Use the virtualizedMenuRenderer, if it's provided and compatible with the other props
    var computedMenuRenderer = this.getMenuRenderer({
      itemComponent: itemComponent,
      menuRenderer: menuRenderer,
      menuWidth: menuWidth,
      optionRenderer: optionRenderer
    });

    // Determine what type of control the dropdown is attached to
    var computedAnchorType = this.getAnchorType({ anchorType: anchorType, multi: multi });

    // A null or undefined value should be considered equivalent to resetValue
    var computedValue = value == null ? resetValue : value;

    if (loadOptions && allowCreate) {
      _devLogger2.default.warn({
        message: 'UISelect: loadOptions and allowCreate are mutually exclusive.',
        key: 'UISelect: asyncCreatable'
      });
    }

    if (rest.autofocus) {
      _devLogger2.default.warn({
        message: "UISelect: The autofocus prop is deprecated in favor of autoFocus to match React's autoFocus prop",
        key: 'UISelect: autofocus'
      });
    }

    if (inputRef && computedAnchorType === 'combined') {
      _devLogger2.default.warn({
        message: 'UISelect: The inputRef prop is only supported with anchorType="input" or anchorType="button"',
        key: 'UISelect: inputRef'
      });
    }

    // Props that are used regardless of anchor type
    var commonProps = _extends({}, rest, {
      backspaceRemoves: multi && computedAnchorType === 'combined',
      clearable: computedAnchorType === 'combined' ? clearable : false,
      disabled: disabled,
      filterOptions: this.filterOptionsProxy,
      id: id,
      ignoreAccents: ignoreAccents,
      ignoreCase: ignoreCase,
      inputProps: this._getInputProps(disabled, id, searchable, computedAnchorType, this.handleAutosize, this.handlePaste, readOnly),
      isLoading: isLoading != null ? isLoading : this.state.isLoading,
      isOpen: open,
      labelKey: 'text',
      loadOptions: loadOptions ? this.loadOptionsProxy : undefined,
      loadingPlaceholder: null,
      menuRenderer: computedMenuRenderer,
      multi: multi,
      noResultsText: this.getNoResultsText({ noResultsText: noResultsText }),
      onChange: this.handleChange,
      onClose: this.handleClose,
      onInputChange: this.handleInputChange,
      onInputKeyDown: this.handleInputKeyDown,
      onOpen: this.handleOpen,
      onPaste: this.handlePaste,
      openAfterFocus: true,
      optionRenderer: this.optionRendererProxy,
      options: loadOptions ? undefined : options,
      placeholder: (0, _lazyEval2.default)(placeholder),
      readOnly: readOnly,
      ref: this.anchorRefCallback,
      renderInvalidValues: true,
      required: false,
      resetValue: resetValue,
      searchable: searchable,
      searchPromptText: (0, _lazyEval2.default)(searchPromptText),
      tabIndex: tabIndex,
      tabSelectsValue: false,
      value: loadOptions ? this.getValueAsObject(computedValue) : computedValue,
      valueComponent: this.getValueComponent({ multi: multi }),
      valueRenderer: valueRenderer || this.defaultValueRenderer
    });

    // We need to attach two ref callbacks to the combined anchor.
    this._refSequence = this._refSequence || (0, _Functions.sequence)(this.anchorRefCallback, this.selectRefCallback);

    // Bootstrap a read-only state on the "external" Select component by disabling interactivity
    // Only needed for the "combined" anchorType - readOnly class prevents disabled styles from being applied
    var readOnlyProps = readOnly ? { disabled: true } : {};

    return _react2.default.createElement(
      _FieldsetContext.Consumer,
      null,
      function (_ref13) {
        var fieldSize = _ref13.size;

        var simpleAnchorClassName = (0, _classNames2.default)(className, SELECT_SIZE_OPTIONS[fieldSize], {
          'private-form__control--error': error
        });

        if (computedAnchorType === 'input') {
          return _react2.default.createElement(_UISelectWithInputAnchor2.default, _extends({}, commonProps, {
            autoFocus: autoFocus,
            className: simpleAnchorClassName,
            dropdownComponent: _this3.renderDropdown,
            error: error,
            inputRef: inputRef,
            inputValue: inputValue,
            onInputValueChange: _this3.handleInputValueChange,
            onOpenChange: onOpenChange,
            selectComponent: SelectComponent,
            selectRef: _this3.selectRefCallback
          }));
        }

        if (_this3.isCollapsed({ multi: multi, multiCollapseLimit: multiCollapseLimit, open: open, value: value })) {
          return _this3.renderCollapsedAnchor(combinedAnchorClassName, multiCollapseLimit, value, valueRenderer, rest);
        }

        if (computedAnchorType === 'button') {
          return _react2.default.createElement(_UISelectWithButtonAnchor2.default, _extends({}, commonProps, {
            autoFocus: autoFocus,
            buttonSize: buttonSize,
            ButtonContent: ButtonContent,
            buttonUse: buttonUse,
            className: simpleAnchorClassName,
            closeOnTargetLeave: closeOnTargetLeave,
            dropdownContentRef: _this3.dropdownContentRefCallback,
            dropdownFooter: _this3.renderDropdownFooter(),
            error: error,
            inputRef: inputRef,
            menuWidth: _this3.getMenuWidth() || 'auto',
            onInputValueChange: _this3.handleInputValueChange,
            onOpenChange: onOpenChange,
            resetOption: resetOption,
            searchClassName: searchClassName,
            searchPlaceholder: (0, _lazyEval2.default)(searchPlaceholder),
            selectComponent: SelectComponent,
            selectRef: _this3.selectRefCallback
          }));
        }

        return _react2.default.createElement(SelectComponent, _extends({
          autofocus: autoFocus
        }, commonProps, {
          className: combinedAnchorClassName,
          dropdownComponent: _this3.renderDropdown,
          ref: _this3._refSequence,
          tabIndex: typeof tabIndex === 'number' ? String(tabIndex) : tabIndex
        }, readOnlyProps));
      }
    );
  }
});

UISelectCore.displayName = 'UISelect';

var UISelect = (0, _Controllable2.default)(UISelectCore, ['open', 'value']);

UISelect.stripDiacritics = stripDiacritics;

exports.default = UISelect;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/UISelect.js
// module id = 329
// module chunks = 3 4 5